import { cn } from "@/lib/utils";
import { Search } from "lucide-react";

/** Champ de recherche arrondi des modales de l'accueil (tutoriels, raccourcis). */
export const HomeSearchInput = ({
  value,
  onChange,
  placeholder,
  autoFocus = false,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  className?: string;
}) => (
  <label
    className={cn(
      "flex items-center gap-2.5 rounded-full bg-slate-100 px-4 py-2 focus-within:ring-2 focus-within:ring-primary",
      className,
    )}
  >
    <Search className="size-4 shrink-0 text-slate-500" aria-hidden />
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
      className="min-w-0 flex-1 bg-transparent text-sm outline-none placeholder:text-slate-500"
    />
  </label>
);
